var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSubtitles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1668422990924,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 894,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.6 198.4h398.933333c46.933333 0 87.466667 17.066667 121.6 49.066667 34.133333 34.133333 49.066667 72.533333 49.066667 121.6v283.733333c0 46.933333-17.066667 87.466667-49.066667 121.6s-72.533333 49.066667-121.6 49.066667h-398.933333c-46.933333 0-87.466667-17.066667-121.6-49.066667-34.133333-34.133333-49.066667-72.533333-49.066667-121.6v-283.733333c0-46.933333 17.066667-87.466667 49.066667-121.6 34.133333-32 74.666667-49.066667 121.6-49.066667z m-57.6 115.2v398.933333h512v-398.933333h-512z m228.266667 113.066667h-113.066667v170.666666h113.066667v57.6h-170.666667v-283.733333h170.666667v55.466667z m226.133333 0h-113.066667v170.666666h113.066667v57.6h-170.666667v-283.733333h170.666667v55.466667z",
    "p-id": 895
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubtitles);
export default __webpack_public_path__ + "static/media/icon-subtitles.bb9135880ea76b5c564148d6044ae7d9.svg";
export { ForwardRef as ReactComponent };